// extracted by mini-css-extract-plugin
export default {"foutmelding":"BasicForm_foutmelding__tnLkP"};